import { containerConfig } from './shared-configs/container-config.js';
import sankeyConfig from './vizOptions/config.js';
import textAndFormConfig from './textAndForm/config.js';
import apply from './apply.js';
import query from './query.js';
import properties from './properties.js';

const config = {
	tagName: 'SegmentControl',
	key: 'tabSelector',
	options: [
		{ icon: 'sankey', ariaLabel: { desc: null, name: 'Sankey' } },
		{ icon: 'text-format', ariaLabel: { desc: 19373, name: 'Text format' } },
		{ icon: 'title-container', ariaLabel: { desc: 12049, name: 'Title and container' } }
	],
	children: [sankeyConfig, textAndFormConfig, containerConfig]
};

const mstrSankey = { config, properties, apply, query };
export { mstrSankey };
